import React from "react";
import Carousel from "react-bootstrap/Carousel";
import { NavLink } from "react-router-dom";

function BrandSlider() {
  return (
    <>
      <div class="col-lg-9 m-auto">
        <div class="row ">
         
            <Carousel>
              <Carousel.Item interval={2000}>
                <div class="row">
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827552/tg3qw22bjpoecbtzzlxw.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/mt6yjs5yotwhh6ocooxl.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/wrrzfhv01wjgakfvyxdn.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/b1gfu5hpjputi4end0fj.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item interval={1000}>
                <div class="row">
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827552/tg3qw22bjpoecbtzzlxw.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/mt6yjs5yotwhh6ocooxl.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/wrrzfhv01wjgakfvyxdn.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/b1gfu5hpjputi4end0fj.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item interval={1000}>
                <div class="row">
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827552/tg3qw22bjpoecbtzzlxw.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/mt6yjs5yotwhh6ocooxl.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/wrrzfhv01wjgakfvyxdn.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/b1gfu5hpjputi4end0fj.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item interval={1000}>
                <div class="row">
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827552/tg3qw22bjpoecbtzzlxw.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/mt6yjs5yotwhh6ocooxl.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/wrrzfhv01wjgakfvyxdn.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                  <div class="col-3 p-md-5">
                    <NavLink to="/about">
                      <img
                        class="img-fluid brand-img"
                        src={
                          "https://res.cloudinary.com/talhakash/image/upload/v1618827551/b1gfu5hpjputi4end0fj.png"
                        }
                        alt="Brand Logo"
                      />
                    </NavLink>
                  </div>
                </div>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>

     
    </>
  );
}

export default BrandSlider;
